import { NavLink } from "react-router";
import { CardMapValue } from "../../Layout/CardLayout";
import { useGetRentListingsQuery } from "../../store/listing/fetchStateListingThunk";
import Card from "../Card/Card";
import styles from "../../shared-styles/Category.module.css";
import ClipLoader from "react-spinners/esm/ClipLoader";

import loadingStyles from "../../shared-styles/loading.module.css";

export default function RentListings() {
  const { data, isLoading, isError } = useGetRentListingsQuery({});

  console.log(data);

  if (isLoading)
    return (
      <div className={loadingStyles.loading}>
        <ClipLoader loading size={200} color="#35a257" />
      </div>
    );
  if (isError) return <h1>Error</h1>;
  if (data?.length === undefined || data?.length === 0) {
    return (
      <section className={`${styles.layout} container`}>
        <p>There is not Places for rent </p>
      </section>
    );
  }

  return (
    <section className={styles.layout}>
      <div className={`container`}>
        <h2>Places for rent</h2>
        <NavLink to="/category/rent" className={styles.ankoerTag}>
          Show more Places for rent
        </NavLink>
        <ul className={styles.cardLayout}>
          {data?.slice(0, 5).map((item: CardMapValue) => {
            return <Card key={item.id} item={item} edit={false} />;
          })}
        </ul>
      </div>
    </section>
  );
}
